import React from 'react';
import { useSelector } from 'react-redux';
import {
  selectCipRegisterFilterVisible,
  selectTileView,
} from './store/selectors';
import CipRegisterSearch from './cip-register-search';
import CipRegisterFilter from './cip-register-filter';
import CipRegisterTile from './cip-register-tile';
import CipRegisterTable from './cip-register-table';

const CipRegisterContent = () => {
  const isFilterVisible = useSelector(selectCipRegisterFilterVisible);
  const showTileView = useSelector(selectTileView);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <CipRegisterSearch />
        </div>
        {isFilterVisible && <CipRegisterFilter />}
        {showTileView ? <CipRegisterTile /> : <CipRegisterTable />}
      </div>
    </div>
  );
};

export default CipRegisterContent;
